import type { Intent } from '@jet/environment/dispatching';
import type { Opt } from '@jet/environment/types/optional';
import type { Page } from '../../models';

/**
 * Parent interface for an intent whose controller is a RouteProvider (and thus
 * can be recognized by Jet's Router).
 *
 * This canonicalizes the presence of two key parts of a public URL: storefront
 * and language (the `l` query parameter).
 */
export interface RouteableIntent extends Intent<Page> {
    /**
     * The storefront present in the URL (ex. "us" or "fr").
     * If one isn't present, a default is inferred.
     */
    storefront: Opt<string>;
    /**
     * The locale present in the URL (ex. "en-US" or "fr-CA").
     * If one isn't present, a default is inferred from the storefront.
     */
    language: Opt<string>;
}

export function isRouteableIntent(
    intent: Intent<unknown>,
): intent is RouteableIntent {
    return 'storefront' in intent && 'language' in intent;
}

// TODO fix misspelled Routeable -> Routable
